import requestAnimationFramePolyfill from 'dom-lib/lib/animation/requestAnimationFramePolyfill';
import cancelAnimationFramePolyfill from 'dom-lib/lib/animation/cancelAnimationFramePolyfill';
export const cancelAnimationTimeout = (frame) => cancelAnimationFramePolyfill(frame.id);
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
export const requestAnimationTimeout = (callback, delay) => {
    let start;
    // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(() => {
        start = Date.now();
    });
    let frame = null;
    const timeout = () => {
        if (Date.now() - start >= delay) {
            callback.call(null);
        }
        else {
            // @ts-ignore
            frame.id = requestAnimationFramePolyfill(timeout);
        }
    };
    // @ts-ignore
    frame = {
        id: requestAnimationFramePolyfill(timeout),
    };
    // @ts-ignore
    return frame;
};
